import { Application } from "@hotwired/stimulus";
const application = Application.start();
// Configure Stimulus development experience
application.debug = false;
window["Stimulus"] = application;
export { application };
// Import application's controllers
import Pwa from "./_pwa_controller";
import Camera from "./_camera_controller";
import GuestUser from "./_guest_user_controller";
import AutocompleteController from "./_autocomplete_controller";
import SortableController from "./_sortable_controller";
import ToastController from "./_toast_controller";
import ScrollspyController from "./_scrollspy_controller";
import ConditionalToggleController from "./_conditional_toggle_controller";
import TooltipController from "./_tooltip_controller";
import SubjectClassificationController from "./_subject_classification_controller";
import VerifRowsController from "./_verif_rows_controller";
import SearchBarController from "./_search_bar_controller";
import MachineSelectionController from "./_machine_selection_controller";
import PhotoModalController from "./_photo_modal_controller";
import SyntaxHighlightController from "./_syntax_highlight_controller";
import CheckboxController from "./_checkbox_controller";
import DarkModeController from "./_dark_mode_controller";
import SplashController from "./_splash_controller";
import PwaInstallController from "./_pwa_install_controller";
import SelectAllController from "./_select_all_controller";
import SwitchSubmitController from "./_switch_submit_controller";
import AutosubmitController from "./_autosubmit_controller";
import TogglePasswordController from "./_toggle_password_controller";
import DisclaimerController from "./_disclaimer_controller";
import DismissButtonController from "./_dismiss_button_controller";
import RegistrationYearController from "./_registration_year_controller";
import FilePreviewController from "./_file_preview_controller";
import MatomoController from "./_matomo_controller";
// Charts
import VerifsChartController from "./charts/verifs_chart";
import BrandsChartController from "./charts/brands_chart";
import MapChartController from "./charts/map_chart";
const controllers = {
    pwa: Pwa,
    camera: Camera,
    "guest-user": GuestUser,
    autocomplete: AutocompleteController,
    sortable: SortableController,
    toast: ToastController,
    scrollspy: ScrollspyController,
    "conditional-toggle": ConditionalToggleController,
    tooltip: TooltipController,
    "subject-classification": SubjectClassificationController,
    "verif-rows": VerifRowsController,
    "search-bar": SearchBarController,
    "machine-selection": MachineSelectionController,
    "photo-modal": PhotoModalController,
    "syntax-highlight": SyntaxHighlightController,
    checkbox: CheckboxController,
    "dark-mode": DarkModeController,
    splash: SplashController,
    "pwa-install": PwaInstallController,
    selectall: SelectAllController,
    "switch-submit": SwitchSubmitController,
    autosubmit: AutosubmitController,
    "toggle-password": TogglePasswordController,
    disclaimer: DisclaimerController,
    "dismiss-button": DismissButtonController,
    "registration-year": RegistrationYearController,
    "file-preview": FilePreviewController,
    matomo: MatomoController,
    "verifs-chart": VerifsChartController,
    "brands-chart": BrandsChartController,
    "map-chart": MapChartController,
};
Object.entries(controllers).forEach(([name, controller]) => {
    application.register(name, controller);
});
